<app-post-thumb-detail class="post-thumb" *ngFor="let post of posts" [post]="post" (selected)="selected.emit($event)">
</app-post-thumb-detail>

<div class="moreButton" *ngIf="hasMorePosts">
  <a (click)="showMoreClicked()">View More <img src="/assets/img/chevron_down.png" /></a>
</div>
